import axios from 'axios'
import forge from 'node-forge'

import config from '@acre/config'

const { GENERAL_INSURANCE_RSA_PUBLIC_KEY_URL, PROTECTION_RSA_PUBLIC_KEY_URL, APPLICATION_RSA_PUBLIC_KEY_URL } = config

export type PublicKey = forge.pki.rsa.PublicKey
export type StringObj = { [key: string]: string }
export type EncryptFn = (value: string) => Promise<string>

const SCHEME = 'RSA-OAEP'
const SCHEME_OPTIONS = { md: forge.md.sha256.create() }

const encryptAndEncode = (publicKey: PublicKey, value: string) => {
  const ciphertext = publicKey.encrypt(value, SCHEME, SCHEME_OPTIONS)
  return forge.util.encode64(ciphertext)
}

// The public keys are available via our file server rather than the webpack build, that
// way we can perform a key rotation without having to re-build or re-deploy the application
const fetchAndEncrypt = async (value: string, url: string) => {
  if (value === '') return ''
  const response = await axios(url)
  const publicPem = response.data
  const publicKey = forge.pki.publicKeyFromPem(publicPem)
  return encryptAndEncode(publicKey, value)
}

export const encryptGiData: EncryptFn = async (value: string) => {
  return fetchAndEncrypt(value, GENERAL_INSURANCE_RSA_PUBLIC_KEY_URL)
}

export const encryptProtectionData: EncryptFn = async (value: string) => {
  return await fetchAndEncrypt(value, PROTECTION_RSA_PUBLIC_KEY_URL)
}

export const encryptApplicationData: EncryptFn = async (value: string) => {
  return fetchAndEncrypt(value, APPLICATION_RSA_PUBLIC_KEY_URL)
}
